import {
  deleteEmployeesBulkSession,
  removeUploadingEmployees,
} from "../../infrastructure/repository/employees-repository";
import {
  translate as t,
  translate,
} from "../../infrastructure/translate/localization";
import { findCompanyId } from "../../infrastructure/repository/company-repository";
import { displayEmployeesEditSummaryPage } from "./displays/display-employees-edit-summary";
import { showErrorMessage } from "../commons/show-error-message";
import { logError, addContextLog } from "../../infrastructure/log";
import { showSuccessMessage } from "../commons/show-success-message";

export async function removeEmployeesBulkSession(employeeIds, showTable) {
  try {
    const companyId = await findCompanyId();
    const { data: employeeSession } = await deleteEmployeesBulkSession({
      companyId,
      employeeIds,
    });
    addContextLog("info", "deleteEmployeesBulkSession", "display-screen", {
      companyId,
    });
    displayEmployeesEditSummaryPage({ employees: employeeSession, showTable });
  } catch (e) {
    logError(e, `Error to deleteEmployeesBulkSession`);

    showErrorMessage(translate("common-messages.basic-error-message"), true);
  }
}

export const removeUninvitedEmployeesById = async ({
  companyId,
  employeeIds,
}) => {
  try {
    await removeUploadingEmployees({ companyId, employeeIds });
    addContextLog("info", "deleteEmployeesBulkSession", "display-screen", {
      companyId,
    });
    showSuccessMessage(
      t(
        `benefits-section.successfully-removed${
          employeeIds.length !== 1 ? "-plural" : ""
        }-message`
      )
    );
  } catch (e) {
    logError(e, `Error to deleteEmployeesBulkSession`);

    showErrorMessage(translate("common-messages.basic-error-message"), true);
  }
};
